(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      /* HCS (6 Jul): Dawn's IntersectionObserver never populated headerBounds
         on some pages (observed on PDPs) so scrolled-past-header never applied.
         Seed bounds from layout at load; the observer can refine them later. */
      var hcsTopSection = this.header.querySelector('.header__top-section');
      var hcsRect = this.header.getBoundingClientRect();
      this.headerBounds = { top: hcsRect.top + window.pageYOffset, bottom: hcsRect.bottom + window.pageYOffset };

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      /* HCS (6 Jul): header height changes when the sticky bar squashes —
         keep --header-height accurate so sticky page elements (PDP buy box)
         can sit below it. The padding transition bubbles transitionend. */
      /* HCS (8 Aug 2026): this used to run on EVERY transitionend. Several
         properties are transitioned, so it fired repeatedly mid-collapse and
         each call reads offsetHeight - a forced synchronous layout in the
         middle of the animation, which is what made the collapse feel slow.
         Now it runs once, when the one transition that actually changes the
         header's height has finished. */
      /* HCS collapse v4 (6 Sep 2026): the property that moves is now the
         header's own `top` (see the CSS note), so that is the one to wait for. */
      /* ⚑ collapse v5 (10 Sep 2026): the property that moves is now `transform`,
         not `top` - see the CSS note. Guarding on 'top' here would mean this
         never fired again and --header-height / --hcs-header-min would go stale
         after the first collapse. */
      this.header.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'transform') return;
        /* ⚑ v5.1: the transform lives on <sticky-header> now and its
           transitionend BUBBLES to the section. `this` IS that element. Accept
           either, and nothing else - the mobile drawer transitions a transform
           too and must not trigger a layout read. */
        if (e.target !== this.header && e.target !== this) return;
        this.setHeaderHeight();
      }.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      /* ⚑ v6: seed the published state, or a page restored mid-scroll paints the
         control row against the wrong one of the two offsets for a frame. */
      document.documentElement.classList.toggle(
        'hcs-hdr-collapsed', this.header.classList.contains('scrolled-past-header'));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      /* HCS (18 Aug 2026): querySelector returns only the FIRST predictive-search
         in the header, which is the desktop bar's. The mobile box is a separate
         instance further down the DOM, so on a phone - the one place the guard
         below actually mattered - it was reading a component that was never
         open. Collect them all. */
      this.predictiveSearchInstances = this.querySelectorAll('predictive-search');
      this.predictiveSearch = this.predictiveSearchInstances[0];

      /* HCS (8 Aug 2026): two scroll fixes.
         1. The listener below is now PASSIVE. It never calls preventDefault,
            but without the flag the browser must wait for this handler before
            it can paint the scroll - the single biggest cause of the site
            feeling sluggish on a phone.
         2. onScroll is coalesced to one animation frame. It was running in
            full on every scroll event, writing classes and reading layout
            many times per frame. */
      this._hcsRafPending = false;
      this.onScrollHandler = function () {
        if (this._hcsRafPending) return;
        this._hcsRafPending = true;
        window.requestAnimationFrame(function () {
          this._hcsRafPending = false;
          this.onScroll();
        }.bind(this));
      }.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      /* The guard above skips EVERY branch of onScroll, including the one that
         un-collapses the header at the top of the page. Without this, focusing
         search while collapsed and then flicking back to the top would leave the
         logo row hidden until the next flick. Re-run the check on the way out. */
      this.addEventListener('focusout', this.onScrollHandler);

      this.createObserver();

      /* HCS UI-7: the collapse slides the top section up by EXACTLY its own
         height, so --hcs-top-h has to stay accurate after load too (logo image
         decode, font swap, rotation). setHeaderHeight only writes it while
         expanded, so this can't record a mid-collapse height. */
      if (typeof ResizeObserver !== 'undefined') {
        var hcsTopEl = this.header.querySelector('.header__top-section');
        if (hcsTopEl) {
          this._hcsTopRO = new ResizeObserver(this.setHeaderHeight.bind(this));
          this._hcsTopRO.observe(hcsTopEl);
        }
      }

      /* HCS UI-3 (26 Jul 2026): keep the mobile BASKET badge in sync with the
         canonical #cart-icon-bubble. Shopify's cart JS replaces that element's
         innerHTML with the cart-icon-bubble section; we mirror it so there is
         still only ONE element with that id in the document. */
      this.hcsMirrorCartBubble();
      this.hcsWatchCartBubble();
      this.hcsBindMobileCart();
    }

    /* HCS UI-3: the mobile BASKET link must behave like the desktop cart icon —
       open the cart drawer rather than navigating to /cart. Falls through to the
       plain href if the drawer isn't on the page. */
    hcsBindMobileCart() {
      var mobileCart = this.querySelector('.header__mobile-action--cart');
      if (!mobileCart) return;
      var openDrawer = function (event) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          drawer.open(mobileCart);
        }
      };
      if (document.querySelector('cart-drawer')) {
        mobileCart.setAttribute('role', 'button');
        mobileCart.setAttribute('aria-haspopup', 'dialog');
      }
      mobileCart.addEventListener('click', openDrawer);
      mobileCart.addEventListener('keydown', function (event) {
        if (event.code && event.code.toUpperCase() === 'SPACE') openDrawer(event);
      });
    }

    hcsMirrorCartBubble() {
      var source = document.getElementById('cart-icon-bubble');
      var target = this.querySelector('[data-hcs-cart-mirror]');
      if (!source || !target) return;
      var bubble = source.querySelector('.cart-count-bubble');
      var existing = target.querySelector('.cart-count-bubble');
      if (bubble) {
        if (existing) {
          if (existing.innerHTML !== bubble.innerHTML) existing.innerHTML = bubble.innerHTML;
        } else {
          target.appendChild(bubble.cloneNode(true));
        }
      } else if (existing) {
        existing.remove();
      }
      /* swap the empty/full basket glyph to match */
      var srcSvg = source.querySelector('.svg-wrapper');
      var tgtSvg = target.querySelector('.svg-wrapper');
      if (srcSvg && tgtSvg && srcSvg.innerHTML !== tgtSvg.innerHTML) {
        tgtSvg.innerHTML = srcSvg.innerHTML;
      }
    }

    hcsWatchCartBubble() {
      var source = document.getElementById('cart-icon-bubble');
      if (!source || typeof MutationObserver === 'undefined') return;
      var self = this;
      this._hcsCartObserver = new MutationObserver(function () {
        self.hcsMirrorCartBubble();
      });
      this._hcsCartObserver.observe(source, { childList: true, subtree: true, characterData: true });
    }

    setHeaderHeight() {
      /* HCS: expose the top section's height so CSS can slide it away smoothly */
      var hcsTop = this.header.querySelector('.header__top-section');
      var collapsed = this.header.classList.contains('scrolled-past-header');
      if (hcsTop && hcsTop.offsetHeight > 0 && !collapsed) {
        this._hcsTopH = hcsTop.offsetHeight;
        document.documentElement.style.setProperty('--hcs-top-h', this._hcsTopH + 'px');
      }
      /* HCS collapse v4 (6 Sep 2026): the header keeps its full height in
         flow and slides by its sticky offset, so offsetHeight no longer says
         how much of it is on screen. --header-height is the VISIBLE height -
         the same numbers it always carried (the whole header expanded, the
         bar alone when stuck), which is what the cart page summary, the
         band anchors and the buy-box fallback size themselves from. */
      var visible = this.header.offsetHeight - (collapsed ? (this._hcsTopH || 0) : 0);
      document.documentElement.style.setProperty('--header-height', `${Math.max(0, visible)}px`);
      /* HCS (8 Sep 2026): --hcs-header-min is the height of the BAR ALONE, and
         unlike --header-height it does not change when the header collapses -
         v4 keeps the header's full height in flow, so offsetHeight minus the top
         section is the same number in both states. Anything that must sit under
         the header WITHOUT moving 133px the moment it collapses sizes itself
         from this instead. The cart page's two boxes are the first user. */
      var barOnly = this.header.offsetHeight - (this._hcsTopH || 0);
      if (barOnly > 0) document.documentElement.style.setProperty('--hcs-header-min', `${barOnly}px`);
      /* ⚑ v6: and the FULL height, which --header-height stopped being the moment
         it started meaning "visible". Anything that must sit under the EXPANDED
         header needs this one; --hcs-header-min is its collapsed twin. Both are
         constants - neither tracks the collapse. */
      if (this.header.offsetHeight > 0) {
        document.documentElement.style.setProperty('--hcs-header-full', `${this.header.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this._hcsCartObserver) this._hcsCartObserver.disconnect();
      if (this._hcsTopRO) this._hcsTopRO.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    /* HCS v3.3: relocate the search bar into the bottom bar while
       collapsed (desktop only). Same node, so predictive search's ids,
       listeners and state all survive. */
    hcsMoveSearch(collapsed) {
      if (window.innerWidth < 990) collapsed = false;
      var search = this.header.querySelector('.header__search-section');
      var bottomWrap = this.header.querySelector('.header__bottom-wrapper');
      var icons = this.header.querySelector('.header__icons-section');
      if (!search || !bottomWrap || !icons) return;
      if (collapsed) {
        if (search.parentNode !== bottomWrap) {
          if (!this._hcsSearchHome) this._hcsSearchHome = { parent: search.parentNode, next: search.nextSibling };
          bottomWrap.insertBefore(search, icons);
        }
      } else if (this._hcsSearchHome && search.parentNode === bottomWrap) {
        this._hcsSearchHome.parent.insertBefore(search, this._hcsSearchHome.next);
      }
    }

    /* HCS (18 Aug 2026, Finbar: "on scroll the type cursor moves up out of the
       box... copy and paste doesn't work in search").
       True whenever a header search box is in use - focused, or showing results.
       While that is true the collapse must not run. Every branch of onScroll
       adds or removes `scrolled-past-header`, which slides .header__top-section
       by its own height and re-lays-out the whole sticky header. iOS does not
       re-anchor a focused input's text caret or its long-press edit callout when
       an ancestor moves, so the caret stayed painted where the box used to be
       and the Select/Paste callout was cancelled mid-gesture. Holding the header
       still whilst the shopper is in the field fixes both. */
    hcsSearchIsBusy() {
      /* Everything below is gated on focus being INSIDE the header, so the
         guard cannot latch on. A bare `isOpen` test could: onFormReset closes
         the results without resetting isOpen, and a fetch that lands after the
         shopper has already blurred calls open() again with nothing focused and
         no focusout left to come - which would have stopped the header ever
         collapsing again for the rest of the page view. */
      var active = document.activeElement;
      if (!active || !this.header.contains(active)) return false;
      if (active.matches && active.matches('input[type="search"]')) return true;
      var instances = this.predictiveSearchInstances || [];
      for (var i = 0; i < instances.length; i++) {
        if (instances[i].isOpen && instances[i].contains(active)) return true;
      }
      return false;
    }

    /* HCS (8 Sep 2026): how far down the page the header waits before it
       collapses. Everywhere but the cart that is the FULL header (Dawn's
       behaviour, unchanged). On the cart it is the TOP SECTION's height, which
       is ~56px sooner here, so the bar is already short and still by the time
       the product and summary boxes reach it.

       ⚑ It cannot go any earlier than the top section's height, however
       tempting. Below that the header has not yet been pinned by its negative
       sticky offset, so the top section is still partly on screen - faded to
       opacity 0 by the collapse class, i.e. a blank white strip above the nav.
       That is the exact fault collapse v4 was written to remove.

       ⚑ And it is the same number as the UN-collapse test below, deliberately:
       matching them means the header cannot flip state twice in one short drag. */
    hcsCollapseFloor() {
      if (this._hcsCollapseEarly === undefined) {
        this._hcsCollapseEarly = window.HCS_COLLAPSE_EARLY === true;
      }
      if (!this._hcsCollapseEarly) return this.headerBounds.bottom;
      /* fail safe: with no measured top section the early floor would be the
         page top, which is the blank-strip fault above. Take Dawn's. */
      if (!this._hcsTopH) return this.headerBounds.bottom;
      return this.headerBounds.top + this._hcsTopH;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const hcsFloor = this.hcsCollapseFloor();

      if (this.hcsSearchIsBusy()) {
        /* keep the baseline current, or the first scroll after the shopper
           leaves the field would be measured against a stale position and the
           bar would jump the wrong way */
        this.currentScrollTop = scrollTop;
        return;
      }

      /* ⚑ v7 (10 Sep 2026, Finbar: "currently when you start to scroll back up
         when you're half way down a page it uncollapses the top bar - this
         shouldn't happen until you get all the way to the top of the page
         anywhere.") THE HEADER EXPANDS ONLY AT THE TOP OF THE PAGE.
         ⚑ v6 briefly expanded it on any upward drag and that is REVERTED, on
         every width. The un-collapse test is the third branch below and it is
         the only one that removes the class. Do not add an upward-scroll branch
         here again. */
      if (scrollTop > this.currentScrollTop && scrollTop > hcsFloor) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > hcsFloor) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top + (this._hcsTopH || 0)) {
        /* HCS collapse v4 (6 Sep 2026): this used to be `<= headerBounds.top`,
           the very top of the page. With the header sliding by its sticky
           offset rather than shrinking, the top section would otherwise start
           scrolling back into view naturally - at opacity 0 - as soon as the
           header's natural position rises above that offset, i.e. one
           top-section height before the page top. So the class comes off
           there instead, and the header slides down to full height while the
           content underneath stays exactly where it is. */
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      /* HCS: header height changes when the bar collapses — keep the CSS var
         fresh so sticky page elements (PDP buy box) sit right under it. */
      var hcsScrolled = this.header.classList.contains('scrolled-past-header');
      if (hcsScrolled !== this._hcsLastScrolled) {
        this._hcsLastScrolled = hcsScrolled;
        /* ⚑ v6: PUBLISH THE STATE ON <html> SO ANYTHING STICKING UNDER THE HEADER
           CAN FOLLOW IT IN CSS ALONE. The header can now expand mid-page, so the
           sub-category control row has to move down with it or the full header
           covers it. Two constants and a class beat the old per-scroll
           measurement: the class is written ONCE per state change, so iOS
           deferring it delays the row and the header together - they can never
           disagree, which is the only thing that ever looked broken. */
        document.documentElement.classList.toggle('hcs-hdr-collapsed', hcsScrolled);
        this.hcsMoveSearch(hcsScrolled);
        var hcsSelf = this;
        requestAnimationFrame(function () { hcsSelf.setHeaderHeight(); });
        /* HCS (8 Aug 2026): was a hardcoded 320ms, which no longer matches the
           unified 240ms collapse and so fired mid-flight, measuring a header
           that was still moving. The transitionend listener above is the
           authority now; this is only a fallback if the transition is skipped
           (reduced-motion, or a background tab). */
        window.clearTimeout(hcsSelf._hcsHeightTimer);
        hcsSelf._hcsHeightTimer = setTimeout(function () { hcsSelf.setHeaderHeight(); }, 400);
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    // Toggle dropdown menus
    const toggles = document.querySelectorAll('.nav-toggle');
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const targetId = this.getAttribute('data-toggle');
        const target = document.getElementById(targetId);
        
        if (target) {
          // Close all other dropdowns at the same level
          const siblings = target.parentElement.parentElement.querySelectorAll('.nav-dropdown, .nav-dropdown-submenu');
          siblings.forEach(sibling => {
            if (sibling !== target && sibling.classList.contains('active')) {
              sibling.classList.remove('active');
            }
          });
          
          // Toggle target
          target.classList.toggle('active');
        }
      });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nav-menu')) {
        document.querySelectorAll('.nav-dropdown, .nav-dropdown-submenu').forEach(dropdown => {
          dropdown.classList.remove('active');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
